import React from 'react';
import Slider from "react-slick";

import { LazyLoadImage } from 'react-lazy-load-image-component';
import '../styles/components/portfolio-detail.scss';


const PortfolioDetail = (props) => {
    const data = props.data;
    var settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true
    };
    return(
        <div>
            <div className="header">
                <h6>{data.catg}</h6>
                <h4>{ data.title }</h4>
            </div>
            <div className="cols">                    
                    <div className="leftCol">                    
                        <div className="content" dangerouslySetInnerHTML={{ __html: data.content }} />
                    </div>
                    <div className="rightCol">
                        {data.images && 
                            <Slider className="clients" {...settings}>
                            {data.images.map((d,i)=>
                                <div key={i}><LazyLoadImage effect="blur" src={d} alt={data.title}/></div>
                            )}
                            </Slider> 
                        }                        
                        <div className="content" dangerouslySetInnerHTML={{ __html: data.content }} />                  
                    </div> 
                </div>
        </div>
    )
}

export default PortfolioDetail;